import { Component } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { UserService } from '../../../services/user/user.service';
import { catchError, of } from 'rxjs';

@Component({
  selector: 'app-promote-to-admin-form',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './promote-to-admin-form.component.html',
  styleUrl: './promote-to-admin-form.component.scss',
})
export class PromoteToAdminFormComponent {
  promoteToAdminForm = new FormGroup({
    userId: new FormControl(0),
  });

  constructor(private userService: UserService) {}

  onSubmit(): void {
    this.userService
      .promoteToAdmin(this.promoteToAdminForm.value.userId!)
      .pipe(
        catchError(() => {
          return of(false);
        })
      )
      .subscribe();
  }
}
